import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22012e06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CrmTasksFilters__holder" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "CrmTasksFilters",
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFiltersChanged && _ctx.onFiltersChanged(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_input, {
        placeholder: "Номер накладной",
        disabled: _ctx.loading,
        value: _ctx.state.invoiceNumber,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.invoiceNumber) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Тип",
        disabled: _ctx.loading,
        options: _ctx.TYPE_OPTIONS,
        "select-by": "name",
        value: _ctx.state.waitListType,
        "onUpdate:value": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.waitListType) = $event)),
          _ctx.onUpdateType
        ]
      }, null, 8, ["disabled", "options", "value", "onUpdate:value"]),
      _createVNode(_component_new_input, {
        placeholder: "Дата создания ЛО с",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.periodFrom,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.periodFrom) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_input, {
        placeholder: "Дата создания ЛО по",
        type: "date",
        disabled: _ctx.loading,
        value: _ctx.state.periodTo,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.periodTo) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Статус",
        disabled: _ctx.loading,
        options: _ctx.STATUS_OPTIONS,
        value: _ctx.state.processingStatusId,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.processingStatusId) = $event))
      }, null, 8, ["disabled", "options", "value"]),
      _createVNode(_component_new_select, {
        "can-deselect": "",
        placeholder: "Источник",
        loading: _ctx.source_state.is_loading,
        failed: _ctx.source_state.is_failed,
        disabled: _ctx.source_state.is_loading,
        searchable: false,
        options: _ctx.source_state.list,
        value: _ctx.state.source,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.source) = $event)),
        onRefresh: _ctx.loadSources,
        "select-by": "title",
        label: "title"
      }, null, 8, ["loading", "failed", "disabled", "options", "value", "onRefresh"]),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--search mr-3",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--reset",
          onClick: _ctx.onFiltersReset
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ], 32))
}